// Deep-link query for Assign to Products (/store-template-editor).
// Product 360 and the template library hand a style / template / design
// so the editor opens on the right garment instead of a blank list.

export type TemplateEditorQuery = {
  templateId: string;
  styleNumber: string;
  designId: string;
};

export function parseTemplateEditorQuery(search: string): TemplateEditorQuery {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const q = new URLSearchParams(raw);
  return {
    templateId: (q.get('template') || '').trim(),
    styleNumber: (q.get('style') || '').trim().toUpperCase(),
    designId: (q.get('design') || '').trim(),
  };
}

export function templateEditorHref(parts: Partial<TemplateEditorQuery>): string {
  const q = new URLSearchParams();
  if (parts.templateId) q.set('template', parts.templateId);
  if (parts.styleNumber) q.set('style', parts.styleNumber);
  if (parts.designId) q.set('design', parts.designId);
  const s = q.toString();
  return s ? `/store-template-editor?${s}` : '/store-template-editor';
}

export function productLineupHref(parts: Partial<Pick<TemplateEditorQuery, 'templateId' | 'styleNumber'>>): string {
  const q = new URLSearchParams();
  if (parts.templateId) q.set('template', parts.templateId);
  if (parts.styleNumber) q.set('style', parts.styleNumber);
  const s = q.toString();
  return s ? `/product-template-editor?${s}` : '/product-template-editor';
}

export function storeTemplateHref(
  id: string,
  styleNumber?: string,
  hint?: { kind?: string | null },
): string {
  if (String(id || '').startsWith('sport-') || hint?.kind === 'sport-artwork') {
    return templateEditorHref({ templateId: id, styleNumber });
  }
  return productLineupHref({ templateId: id, styleNumber });
}
